<div class="card">
  <div class="card-header">
    <h5 class="card-title">Senior Managers &amp; Certification Regime</h5>
    <h6 class="card-subtitle">Individual Assessments, Statements of Responsibility and Certificates</h6>
    <h6 class="card-subtitle text-body-secondary mt-2">UK</h6>
  </div>
  <div class="card-body">
    <form [formGroup]="form">
      <h6>1. Personal Particulars</h6>
      <p>Name: {{ user?.name }}</p>
      <p>Title: {{ user?.title }}</p>
      <div class="mb-3" style="width: 25%">
        <ejs-textbox placeholder="IRN" formControlName="irn" floatLabelType="Auto" />
        <small class="form-text text-muted">If applicable</small>
      </div>

      <!-- Section 2 -->
      <h6 class="mt-3">2. Annual SM&amp;CR Competence Assessment</h6>
      <ol>
        <li>
          <div class="d-flex justify-content-between align-items-center">
            Is the individual a Senior Manager?
            <ejs-switch formControlName="s2Q1" onLabel="YES" offLabel="NO" />
          </div>

          <!-- s2Q1HeldFunctions -->
          @if (form.controls.s2Q1.value === true) {
            <ejs-multiselect
              #s2Q1HeldFunctions
              [dataSource]="s2Q1HeldFunctionsOptions$ | async"
              formControlName="s2Q1HeldFunctions"
              mode="CheckBox"
              [showSelectAll]="true"
              placeholder="If yes, what functions are held?"
              floatLabelType="Auto"
            />
          }

          <!-- s2Q1PrescribedResponsibilities -->
          @if (form.controls.s2Q1.value === true) {
            <ejs-multiselect
              #s2Q1PrescribedResponsibilities
              [dataSource]="s2Q1PrescribedResponsibilitiesOptions$ | async"
              formControlName="s2Q1PrescribedResponsibilities"
              mode="CheckBox"
              [showSelectAll]="true"
              placeholder="If yes, what prescribed responsibilities are they responsible for?"
              floatLabelType="Auto"
            />
          }
          @if (form.controls.s2Q1.touched && form.controls.s2Q1.hasError('required')) {
            <small class="text-danger d-block">This field is required.</small>
          }
        </li>
        <li>
          <div class="d-flex justify-content-between align-items-center">
            Is the individual subject to the Certification Regime?
            <ejs-switch formControlName="s2Q2" onLabel="YES" offLabel="NO" />
          </div>

          <!-- s2Q2HeldCertificationFunctions -->
          @if (form.controls.s2Q2.value === true) {
            <ejs-multiselect
              #s2Q2HeldCertificationFunctions
              [dataSource]="s2Q2HeldCertificationFunctionsOptions$ | async"
              formControlName="s2Q2HeldCertificationFunctions"
              mode="CheckBox"
              [showSelectAll]="true"
              placeholder="If yes, what certification functions are held?"
              floatLabelType="Auto"
            />
          }
          @if (form.controls.s2Q2.touched && form.controls.s2Q2.hasError('required')) {
            <small class="text-danger d-block">This field is required.</small>
          }
        </li>
        <li>
          Responsibilities
          <ol type="a">
            <li>
              <div class="mb-3" style="margin-top: 1rem">
                <label class="form-label">Indicate the nature of your role within the Company?</label>
                <ejs-textbox multiline="true" rows="4" formControlName="s2Q3a"></ejs-textbox>
                @if (form.controls.s2Q3a.touched && form.controls.s2Q3a.hasError('required')) {
                  <small class="text-danger d-block">This field is required.</small>
                }
              </div>
            </li>
            <li class="align-top">
              <div class="mb-3" style="margin-top: 1rem">
                <label class="form-label"
                  >Has the nature of your activities changed (e.g. reduced/expanded) in the past year?</label
                >
                <ejs-textbox multiline="true" rows="4" formControlName="s2Q3b"></ejs-textbox>
                @if (form.controls.s2Q3b.touched && form.controls.s2Q3b.hasError('required')) {
                  <small class="text-danger d-block">This field is required.</small>
                }
              </div>
            </li>
          </ol>
        </li>
        <li>
          Reporting Line
          <div class="mb-3" style="margin-top: 1rem">
            <label class="form-label">To whom do you directly report to?</label>
            <ejs-textbox multiline="true" rows="4" formControlName="s2Q4"></ejs-textbox>
            @if (form.controls.s2Q4.touched && form.controls.s2Q4.hasError('required')) {
              <small class="text-danger d-block">This field is required.</small>
            }
          </div>
        </li>
        <li>
          Compliance &amp; AML Procedures
          <div class="mb-3" style="margin-top: 1rem">
            <label class="form-label"
              >Are you familiar with the Company&lsquo;s procedures detailed in the Compliance Manual and AML
              Handbook?</label
            >
            <ejs-textbox multiline="true" rows="4" formControlName="s2Q5"></ejs-textbox>
            @if (form.controls.s2Q5.touched && form.controls.s2Q5.hasError('required')) {
              <small class="text-danger d-block">This field is required.</small>
            }
          </div>
        </li>
        <li>
          Fitness, Honesty &amp; Propriety
          <div class="mb-3" style="margin-top: 1rem">
            <label class="form-label"
              >Are you aware of any changes in your personal circumstances which may affect your ongoing fitness and
              propriety?</label
            >
            <ejs-textbox multiline="true" rows="4" formControlName="s2Q6"></ejs-textbox>
            @if (form.controls.s2Q6.touched && form.controls.s2Q6.hasError('required')) {
              <small class="text-danger d-block">This field is required.</small>
            }
          </div>
        </li>
        <li>
          Skills, Knowledge &amp; Expertise
          <ol type="a">
            <li>
              <div class="mb-3" style="margin-top: 1rem">
                <label class="form-label"
                  >Please document an evaluation of your skills, expertise, and knowledge of the changes in the market,
                  to products, legislation and regulation. Are they up-to-date?</label
                >
                <ejs-textbox multiline="true" rows="4" formControlName="s2Q7a"></ejs-textbox>
                @if (form.controls.s2Q7a.touched && form.controls.s2Q7a.hasError('required')) {
                  <small class="text-danger d-block">This field is required.</small>
                }
              </div>
            </li>
            <li>
              <div class="mb-3" style="margin-top: 1rem">
                <label class="form-label">Is your regulatory knowledge up-to-date?</label>
                <ejs-textbox multiline="true" rows="4" formControlName="s2Q7b"></ejs-textbox>
                @if (form.controls.s2Q7b.touched && form.controls.s2Q7b.hasError('required')) {
                  <small class="text-danger d-block">This field is required.</small>
                }
              </div>
            </li>
          </ol>
        </li>
        <li>
          Training &amp; Qualifications
          <ol type="a">
            <li>
              <div class="mb-3" style="margin-top: 1rem">
                <label class="form-label"
                  >What training have you been given during the past year? This includes training provided by us,
                  conferences, seminars, online and on-the-job training. Please also include any exams you may have
                  passed.</label
                >
                <ejs-textbox multiline="true" rows="4" formControlName="s2Q8a"></ejs-textbox>
                @if (form.controls.s2Q8a.touched && form.controls.s2Q8a.hasError('required')) {
                  <small class="text-danger d-block">This field is required.</small>
                }
              </div>
            </li>
            <li>
              <div class="mb-3" style="margin-top: 1rem">
                <label class="form-label"
                  >Is there any area in which you feel you would benefit from receiving training?</label
                >
                <ejs-textbox multiline="true" rows="4" formControlName="s2Q8b"></ejs-textbox>
                @if (form.controls.s2Q8b.touched && form.controls.s2Q8b.hasError('required')) {
                  <small class="text-danger d-block">This field is required.</small>
                }
              </div>
            </li>
          </ol>
        </li>
      </ol>

      @if (!onBehalfOf && alreadySubmitted) {
        <h6>3. Declaration</h6>
        <p>
          I hereby confirm and declare that all the information provided herein to be complete, true, and correct
          regarding my fitness and propriety to perform the roles detailed above. I further understand and acknowledge
          that it is my personal responsibility to notify CIGP, immediately and in writing, in the event that any of the
          information contained herein changes.
        </p>
        <p>
          Name: {{ user?.name }}<br />
          Date: {{ declarationDate | date }}
        </p>
      }
    </form>
    <div class="btn-group">
      @if (alreadySubmitted) {
        <button class="btn btn-primary" disabled>YOU ALREADY SUBMITTED THIS DECLARATION</button>
      } @else {
        <button class="btn btn-primary" [disabled]="!form.valid" (click)="saveOrSubmitForm()">SUBMIT</button>
      }
      <button class="btn btn-secondary" (click)="location.back()">BACK</button>
    </div>
  </div>
</div>

<!-- Syncfusion Acknowledgement Dialog -->
<ejs-dialog #ackDialog [(visible)]="showAckDialog" width="600px" [isModal]="true">
  <ad-uk-smcr-ack-dialog [data]="ackDialogData" (closeDialog)="handleDialogClose($event)"> </ad-uk-smcr-ack-dialog>
</ejs-dialog>
